import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import * as XLSX from 'xlsx';

@Component({
  selector: 'app-datewise',
  templateUrl: './datewise.component.html',
  styleUrls: ['./datewise.component.scss'],
})
export class DatewiseComponent implements OnInit {
  datewisedata;
  today = new Date();
  startdate = '';
  enddate = '';
  datewiselist = [];
  tempdata = [];
  isLoading: boolean = false;
  subTypesName = [
    { name: 'वार्षिक', isVisible: false },
    { name: 'त्रैवार्षिक', isVisible: false },
    { name: 'पंचवार्षिक', isVisible: false },
    // { name: 'मुदत ठेव (पंचवार्षिक वर्गणीदार)', isVisible: false },
    // { name: 'रामसेवक ग्रंथयात्री', isVisible: false },
    // { name: 'लोकनेता गंथयात्री वार्षिक', isVisible: false },
    // { name: 'लोकमान्य ग्रंथयात्री वार्षिक वर्गणी', isVisible: false },
    // { name: 'हिंदुत्व ग्रंथयात्री', isVisible: false },
    // { name: 'हिंदुत्व 1', isVisible: false },
    // { name: 'हिंदुत्व 2', isVisible: false },
    // { name: 'आजीव', isVisible: false },
    // { name: 'अनामत', isVisible: false },
  ];
  totalth = 0;
  finalData = [];
  appliedFilters: any = {};  

  constructor(
    private dialogref: MatDialogRef<DatewiseComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  ngOnInit(): void {
    this.isLoading = true;
    this.datewisedata = this.data['datewisedata'];
    this.startdate = this.data['startdate'];
    this.enddate = this.data['enddate'];
    // console.log(formatDate(new Date(), 'MMMM', 'en-IN', 'GMT+0530'));
    let data = this.uniqueData(this.datewisedata, (a) => a.subscription_type);

    for (let i = 0; i < Object.keys(data).length; i++) {
      let flag = false;
      for (let j = 0; j < Object.keys(this.subTypesName).length; j++) {
        if (data[i]['subscription_type'] === this.subTypesName[j]['name']) {
          this.subTypesName[j]['isVisible'] = true;
          flag = true;
          break;
        }
      }
      if (!flag) {
        // if (
        //   data[i]['Subscription_Type'] !== 'हितचिंतक सप्रेम भेट' ||
        //   data[i]['Subscription_Type'] !== 'सप्रेम भेट - संपादकीय विभाग' ||
        //   data[i]['Subscription_Type'] !== 'जाहिरात स. भेट' ||
        //   data[i]['Subscription_Type'] !== 'संघ परिवार सप्रेम भेट' ||
        //   data[i]['Subscription_Type'] !== 'वर्गणी सप्रेम भेट'
        // ) {
        this.subTypesName.push({
          name: data[i]['subscription_type'],
          isVisible: true,
        });
        // }
      }
    }

     this.appliedFilters = this.data['appliedFilters'] || {};

     console.log("Applied Filters:", this.appliedFilters);
    
    // this.totalth = this.subTypesName.length * 3 + 3;
   
    this.totalth = this.subTypesName.filter(b => b.isVisible).length * 4 + 4;

    this.setData();
  }

  //Old Method
  // setData() {
  //   // console.log(this.rojmelData);
  //   let uniqueDateData = this.uniqueData(
  //     this.datewisedata,
  //     (a) => a.entry_date
  //   );
  //   uniqueDateData.sort((a: any, b: any) => {
  //     return (
  //       new Date(a.entry_date).getTime() - new Date(b.entry_date).getTime()
  //     );
  //   });
  //   // console.log(
  //   // );
  //   let finalTotal = {};
  //   this.subTypesName.map((b: any, i) => {
  //     if (b.isVisible) {
  //       let name = this.getKey(b.name);
  //       finalTotal[name + '_एकूण'] = 0;
  //       finalTotal[name + '_नवीन'] = 0;
  //       finalTotal[name + '_नूतनीकरण'] = 0;
  //       if (i == 0) {
  //         finalTotal['name'] = 'एकूण';
  //         finalTotal['एकूण'] = 0;
  //         finalTotal['नवीन'] = 0;
  //         finalTotal['नूतनीकरण'] = 0;
  //       }
  //     }
  //   });

  //   for (let i = 0; i < uniqueDateData.length; i++) {
  //     let datewiseData = this.datewisedata.filter((a) => {
  //       return a.entry_date === uniqueDateData[i]['entry_date'];
  //     });
  //     // console.log(datewiseData);
  //     let totalData = {};
  //     this.subTypesName.map((b: any, i) => {
  //       if (b.isVisible) {
  //         let name = this.getKey(b.name);
  //         totalData[name + '_एकूण'] = 0;
  //         totalData[name + '_नवीन'] = 0;
  //         totalData[name + '_नूतनीकरण'] = 0;
  //         if (i == 0) {
  //           totalData['एकूण'] = 0;
  //           totalData['नवीन'] = 0;
  //           totalData['नूतनीकरण'] = 0;
  //         }
  //       }
  //     });
  //     datewiseData.map((a: any, i) => {
  //       if (i == 0) totalData['entry_date'] = a.entry_date;
  //       let name = this.getKey(a.subscription_type);
  //       totalData['crdt_voucher_date']=a.crdt_voucher_date
  //       totalData[name + '_एकूण'] += parseInt(a.total_amt);
  //       finalTotal[name + '_एकूण'] += parseInt(a.total_amt);
  //       totalData[name + '_नवीन'] += a.rcpt_type == 'New' ? 1 : 0;
  //       finalTotal[name + '_नवीन'] += a.rcpt_type == 'New' ? 1 : 0;
  //       totalData[name + '_नूतनीकरण'] += a.rcpt_type == 'Renew' ? 1 : 0;
  //       finalTotal[name + '_नूतनीकरण'] += a.rcpt_type == 'Renew' ? 1 : 0;
  //       totalData['एकूण'] += parseInt(a.total_amt);
  //       finalTotal['एकूण'] += parseInt(a.total_amt);
  //       totalData['नवीन'] += a.rcpt_type == 'New' ? 1 : 0;
  //       finalTotal['नवीन'] += a.rcpt_type == 'New' ? 1 : 0;
  //       totalData['नूतनीकरण'] += a.rcpt_type == 'Renew' ? 1 : 0;
  //       finalTotal['नूतनीकरण'] += a.rcpt_type == 'Renew' ? 1 : 0;
  //     });
  //     // datewiseData.push(totalData);
  //     this.finalData.push(totalData);
  //   }
  //   this.finalData.push(finalTotal);
  //   // console.log(this.finalData);
  //   this.isLoading = false;
  // }

  //New Code 
setData() {
  this.finalData = [];
  this.isLoading = true;

  // Step 1: Get unique date list
  const uniqueDateData = this.uniqueData(this.datewisedata, (a: any) => a?.crdt_voucher_date) as { crdt_voucher_date: string }[];

  // Step 2: Sort by date
  uniqueDateData.sort((a, b) => {
    const dateA = new Date(a.crdt_voucher_date).getTime();
    const dateB = new Date(b.crdt_voucher_date).getTime();
    return dateA - dateB;
  });

  // Step 3: Initialize final total
  let finalTotal: any = {
    name: 'एकूण',
    एकूण: 0,
    नवीन: 0,
    नूतनीकरण: 0,
  };

  this.subTypesName.forEach((sub: any) => {
    if (sub.isVisible) {
      const key = this.getKey(sub.name);
      finalTotal[key + '_एकूण'] = 0;
      finalTotal[key + '_नवीन'] = 0;
      finalTotal[key + '_नूतनीकरण'] = 0;
    }
  });

  // Step 4: Loop through each date
  for (let i = 0; i < uniqueDateData.length; i++) {
    const currentDate = uniqueDateData[i]?.crdt_voucher_date ?? '';
    const datewiseData = this.datewisedata.filter((a: any) => a.crdt_voucher_date === currentDate);

    // Initialize subtotal for the current date
    let subtotal: any = {
      crdt_voucher_date: currentDate,
      _isTotalRow: true,
      एकूण: 0,
      नवीन: 0,
      नूतनीकरण: 0,
    };

    this.subTypesName.forEach((sub: any) => {
      if (sub.isVisible) {
        const key = this.getKey(sub.name);
        subtotal[key + '_एकूण'] = 0;
        subtotal[key + '_नवीन'] = 0;
        subtotal[key + '_नूतनीकरण'] = 0;
      }
    });

    // Step 5: Process each record for the date
    datewiseData.forEach((record: any) => {
      const key = this.getKey(record.subscription_type);
      const amt = parseInt(record.total_amt, 10) || 0;

      // Push individual record with subtype-wise data
      let individualRow: any = { ...record, _isIndividual: true };
      this.subTypesName.forEach((sub: any) => {
        if (sub.isVisible) {
          const subKey = this.getKey(sub.name);
          individualRow[subKey + '_एकूण'] = subKey === key ? amt : 0;
          individualRow[subKey + '_नवीन'] = (subKey === key && record.rcpt_type === 'New') ? 1 : 0;
          individualRow[subKey + '_नूतनीकरण'] = (subKey === key && record.rcpt_type === 'Renew') ? 1 : 0;
        }
      });
      this.finalData.push(individualRow);

      // Update subtotal
      subtotal[key + '_एकूण'] += amt;
      subtotal['एकूण'] += amt;

      if (record.rcpt_type === 'New') {
        subtotal[key + '_नवीन'] += 1;
        subtotal['नवीन'] += 1;
      } else if (record.rcpt_type === 'Renew') {
        subtotal[key + '_नूतनीकरण'] += 1;
        subtotal['नूतनीकरण'] += 1;
      }

      // Update final total
      finalTotal[key + '_एकूण'] += amt;
      finalTotal['एकूण'] += amt;

      if (record.rcpt_type === 'New') {
        finalTotal[key + '_नवीन'] += 1;
        finalTotal['नवीन'] += 1;
      } else if (record.rcpt_type === 'Renew') {
        finalTotal[key + '_नूतनीकरण'] += 1;
        finalTotal['नूतनीकरण'] += 1;
      }
    });

    this.finalData.push(subtotal);
  }

  // Step 6: Push final total
  this.finalData.push(finalTotal);

  this.isLoading = false;
}


getKey(name: string): string {
  return name.trim().replace(/\s+/g, '_');
}


  // getKey(name) {
  //   return name.replaceAll(' ', '_');
  // }

  uniqueData(data, key) {
    return [...new Map(data.map((a) => [key(a), a])).values()];
  }

  exportExcel(fileName) {
    /* table id is passed over here */
    let element = document.getElementById('print-section');
    const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);

    /* generate workbook and add the worksheet */
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

    /* save to file */
    XLSX.writeFile(wb, fileName + '.xlsx');
  }

    //Main Report Method Use in all Printing Page
  show = false
  printPage() {
    this.show = true
    const printContent = document.getElementById('print-section')?.outerHTML;
    if (!printContent) {
      console.error("Print section not found!");
      return;
    }

    const printWindow = window.open('', '', 'width=1400,height=1000,top=50,left=50,scrollbars=yes');

    if (printWindow) {
      printWindow.document.open();
      printWindow.document.write(`
             <html>
                 <head>
                     <title>Print Report</title>
                     <style>
                         @media print {
                             @page { 
                                 size: A3 landscape; /* Set A3 size with landscape mode */
                                 margin: 5mm; /* Adjust margins */
                             }
                             body { 
                                 font-family: Arial, sans-serif; 
                                 font-size: 15px; /* Adjust font size */
                                 margin: 0; 
                                 padding: 5mm; 
                                 line-height: 1.2; 
                             }
                             table { 
                                 width: 100%; 
                                
                                 border-collapse: collapse; 
                                 table-layout: fixed; /* Prevent column expansion */
                                 page-break-inside: avoid; /* Avoid breaking the table */
                             }
                             th, td { 
                                 padding: 2px; 
                                 border: 1px solid black; 
                                 text-align: center; 
                                 font-size: 14px; /* Adjusted font size */
                                 line-height: 1.2; 
                             }
                             .noPrint { 
                                 display: none; /* Hide print button */
                             }
                         }
                     </style>
                 </head>
                 <body>
                     <div id="print-section">
                         ${printContent}
                     </div>
                     <script>
                         window.onload = function() { 
                             window.print(); 
                             setTimeout(() => { window.close(); }, 500);
                         };
                     </script>
                 </body>
             </html>
         `);
      printWindow.document.close();
    } else {
      console.error("Failed to open print window.");
    }
  }

}
